import React from "react";
import ReactDOM from "react-dom";
import { motion, AnimatePresence } from "framer-motion";

export default function ErrorPopup({
  isOpen,
  title = "Error",
  message = "Something went wrong. Please try again.",
  onClose,
}) {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <AnimatePresence>
      <div
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 99999,
          backdropFilter: "blur(2px)",
        }}
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "20px",
            width: "478px",
            padding: "20px",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Warning Icon like swal */}
          <div style={{ marginBottom: "15px", marginTop: "10px" }}>
            <svg
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="40" cy="40" r="38" stroke="#f8bb86" strokeWidth="4" />
              <rect x="38" y="20" width="4" height="24" rx="2" fill="#f8bb86" />
              <circle cx="40" cy="54" r="3" fill="#f8bb86" />
            </svg>
          </div>

          {/* Centered bold title */}
          <h2
            style={{
              fontFamily: "inherit",
              fontWeight: "500",
              fontSize: "22px",
              color: "#111111",
              textAlign: "center",
              margin: "0 0 10px 0",
            }}
          >
            {title}
          </h2>

          {/* Centered description text */}
          <p
            style={{
              fontFamily: "inherit",
              fontWeight: "400",
              fontSize: "16px",
              lineHeight: "1.5",
              color: "#545454",
              textAlign: "center",
              margin: "0 0 25px 0",
              width: "100%",
            }}
          >
            {message}
          </p>

          {/* Buttons Row: OK Button */}
          <div
            style={{
              display: "flex",
              gap: "10px",
              width: "100%",
              justifyContent: "center",
              marginTop: "15px",
            }}
          >
            <button
              onClick={onClose}
              style={{
                backgroundColor: "#205a46",
                color: "#ffffff",
                border: "1px solid #205a46",
                borderRadius: "10px",
                padding: "8px 20px",
                fontFamily: "inherit",
                fontWeight: "500",
                fontSize: "14px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "80px",
                outline: "none",
              }}
            >
              OK
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>,
    document.body
  );
}
